/* Firebase Web client — inicialización perezosa (idempotente).
   Solo activa si REACT_APP_FIREBASE_API_KEY y REACT_APP_FIREBASE_VAPID_KEY están definidos.
*/
import { initializeApp, getApps } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

export function isFirebaseConfigured() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && VAPID_KEY);
}

export function getFirebase() {
  if (!isFirebaseConfigured()) return null;
  return getApps()[0] || initializeApp(firebaseConfig);
}
